import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, registerPackageExport, packageExports, packageName, } = linkedPackage('profile-plus');
//# sourceMappingURL=package.js.map